
<template>
 <div class="main-section">
    <div class="card big-paddings">
    <form class="login-form" @submit.prevent="SubmitBusinessComments($event)">
        <h1>Gofarma en tu empresa</h1>
        <select name="request" id="request" class="form-control left">
            <option selected disabled>Seleccione el tipo de solicitud</option>
            <option value="Informacion">Informacíon</option>
            <option value="Cotizacion">Cotizacíon</option>
        </select>
        <!--request-->
        <input type="text" class="form-control left" required name="companyName" id="companyName" placeholder="Nombre de la empresa">
        <select name="companyType" id="companyType" class="form-control left"  required>
            <option value="" selected="" hidden="" disabled="">Selecciona el tipo de negocio</option>
            <option value="Asilo">Asilo</option>
            <option value="Clinica">Clínica / Consultorio</option>
            <option value="Comercio">Comercio de venta al público en general</option>
            <option value="Estetica">Estética</option>
            <option value="Guarderia">Guardería</option>
            <option value="Hospital">Hospital</option>
            <option value="Médico">Médico particular</option>
            <option value="Oficina">Oficina</option>
            <option value="Farmacia">Farmacia</option>
            <option value="Restaurante">Restaurante</option>
            <option value="">Otro</option>
        </select>
        <input type="text" name="contactPage" id="contactPage" class="form-control left" placeholder="Página de Internet o red social (opcional)"/>
        <input type="text" name="contactName" id="contactName" class="form-control left" placeholder="Nombre de contacto"  required />
        <select name="preferredContact" id="preferredContact" class="form-control left" required >
            <option value="" selected hidden disabled>Medio preferido de contacto</option>
            <option value="Email">Correo electrónico</option>
            <option value="Telefono">Teléfono</option>
            <option value="Cualquiera">Cualquiera</option>
            </select>
        <input type="email" class="form-control left" required name="emailContent" id="emailContent" placeholder="Correo electronico">
        <input type="number" class="form-control left" required name="phone" id="phone" placeholder="Telefono">
        <textarea cols="30" rows="10" class="form-control left" name="description" id="description" placeholder="Mensaje"></textarea> 
        <div class="mid-container">
            <button class="ui blue button wide" type="submit">Enviar</button>
        </div>
    </form>
    </div>
 </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
    methods:{
        ...mapActions(['SubmitBusinessComments'])
    }
}
</script>
<style scoped>
.card {
    position: relative;
    box-shadow: 0 0.125rem 0.375rem 0 rgba(0, 0, 0, 0);
    transition: 0.3s;
    margin: 0.3125rem;
    box-sizing: border-box;
    text-align: justify;
}
.card form{
    text-align:center;
}

.btn-light-blue {
    width: 30%;
    font-weight: bold;
    color:white;
}

select {
   color: var(--blue-gofarma);
}
.form-control {
    width: 90%;
    min-height: 1.5625rem;
    padding: 0.312rem 0.625rem;
    line-height: 1.6;
    background-color: #fff;
    border: 0.0625rem solid #ddd;
    border-radius: 0.25rem;
    outline: 0;
    margin-bottom:1em;
    text-align: center;
    box-sizing: border-box;
  
}
input{
    color:var(--blue-gofarma);
}
 input.btn-light{
    color:#fafafa;
}
form h1 {
    width: 90%;
    text-align: left;
    color: var(--dark-gofarma);
    font-weight: bold;
    padding-left: 0;
    margin:auto;
}
</style>